import { collection, doc, getDocs, query, setDoc, where } from "firebase/firestore";
import { firebaseStore } from "../../../firebase";
import axios from "axios";
export function initMypageBusinessCardIndex() {
    const form = document.getElementById("businessCardIndexApproveForm");
    if (form === null) {
        return;
    }
    // イベントリスナー設定
    const cardApproveBtns = document.getElementsByClassName("card-approve");
    for (let i = 0; i < cardApproveBtns.length; i++) {
        cardApproveBtns[i].addEventListener("click", function (event) {
            sendCardTradeApprovedMessage(event);
        }, false);
    }
    const cardDisapproveBtns = document.getElementsByClassName("card-disapprove");
    for (let i = 0; i < cardDisapproveBtns.length; i++) {
        cardDisapproveBtns[i].addEventListener("click", function (event) {
            disapprove(event);
        }, false);
    }
    // 承認処理
    function approve(event) {
        const id = event.target.dataset.approveId;
        const form = document.getElementById("businessCardIndexApproveForm");
        const hidden = document.getElementById("approve-id");
        hidden.value = id;
        form.submit();
    }
    // 否認処理
    function disapprove(event) {
        const id = event.target.dataset.disapproveId;
        const form = document.getElementById("businessCardIndexDisapproveForm");
        const hidden = document.getElementById("disapprove-id");
        hidden.value = id;
        form.submit();
    }
    // 名刺交換の承認をサプライヤーへ通知
    const sendCardTradeApprovedMessage = async (event) => {
        const userId = event.target.dataset.userId;
        const supplierId = event.target.dataset.supplierId;
        let roomId = null;
        const q = query(collection(firebaseStore, "rooms"), where("supplierId", "==", Number(supplierId)), where("userId", "==", Number(userId)));
        const res = await getDocs(q);
        res.forEach(async (room) => {
            roomId = room.id;
        });
        const item = {
            roomId: roomId,
            content: `名刺交換を承認しました。`,
            type: "offer__business-card",
            supplierMessage: false,
            opened: false,
            sentAt: {
                seconds: Math.floor(Date.now() / 1000),
                nanoseconds: 0,
            },
        };
        const ref = collection(firebaseStore, "rooms", roomId, "messages");
        await setDoc(doc(ref), item).then(async () => {
            const param = {
                user_id: userId,
                supplier_id: supplierId,
            };
            // 通知済に更新(business_card_trade_historiesテーブルのchat_notifyをnullから1に更新)
            await axios.post("/api/supplier/update-business-card-trade-notify", param);
            // 承認処理(通知が2回されるのでここで実行)
            approve(event);
        });
    };
}
